export * from "./category-statics";
export * from "./categories-resource";
